
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import React from 'react';
import { apolloOptions, APP_NAME, authOptions } from '@apps/config';
import { useThemeConfig } from '@apps/config/theme.config';
import { Layout } from '@apps/layouts';
import SessionReminderProvider from '@apps/providers/SessionReminderProvider';
import type { EmotionCache } from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { createEmotionCache, LayoutConfigProvider } from '@webbyx/mui';
import { useAuthIdentity, withApolloClient, withAuthIdentity, withRouteIndicator, } from '@webbyx/next-js';
import compose from 'lodash/flowRight';
import { NextPage } from 'next';
import { AppProps } from 'next/app';
import Head from 'next/head';
import 'animate.css';
import '@stack/theme/styles/globals.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
type ExtendedAppProps = AppProps & {
    Component: NextPage;
    emotionCache: EmotionCache;
};
const clientSideCache = createEmotionCache();
/**
 * ===========================
 * MAIN
 * ===========================
 */
const MyApp = (props: ExtendedAppProps) => {
    const { Component, router, pageProps, emotionCache = clientSideCache, } = props;
    const config = useThemeConfig();
    const { authUser } = useAuthIdentity();
    const setPageThemeSettings = Component.setPageThemeSettings ?? undefined;
    return (<CacheProvider value={emotionCache}>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1 maximum-scale=1"/>
        <title>{APP_NAME}</title>
      </Head>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <LayoutConfigProvider authUser={authUser} config={config} pageSettings={setPageThemeSettings?.()} paths={[router.asPath, router.pathname]}>
          <Layout>
            <SessionReminderProvider>
              <Component {...pageProps}/>
            </SessionReminderProvider>
          </Layout>
        </LayoutConfigProvider>
      </LocalizationProvider>
    </CacheProvider>);
};
const __Next_Translate__Page__196e3929b41__ = compose(withApolloClient({ ssr: true, options: apolloOptions }), withAuthIdentity({ ssr: true, apollo: true, options: authOptions }), withRouteIndicator())(MyApp);

    export default __appWithI18n(__Next_Translate__Page__196e3929b41__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      
    });
  